/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
/* eslint-disable
    new-cap
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React from 'react';
import _ from 'underscore';

import isArchived from 'archive/isArchived';
import {assert} from 'Asserts';
import * as benchlingUtil from 'BenchlingUtil';
import {NOTEBOOK_SECTION} from 'constants/FileBrowserConstants';
import * as FolderConstants from 'constants/FolderConstants';
import ModelTypeConstants, {NOTEBOOK_ITEMS} from 'constants/ModelTypeConstants';
import {PROJECT_TYPE, REGISTRY_TYPE} from 'constants/SourceConstants';
import FileBrowserActions from 'file-browser/FileBrowserActions';
import ImportSequenceModalClass from 'import-sequence/ImportSequenceModal';
import notifications from 'notifications';
import legacyRunModal from 'ui-library/legacyRunModal';
import APIUtil from 'util/APIUtil';
import * as modals from 'util/Modals';
import {capwords, typeToName} from 'util/NameUtil';

import BenchlingData, {FILES_MIME_TYPE, SOURCES_MIME_TYPE, TFI_MIME_TYPE} from './BenchlingData';
import DropTargetClass from './DropTarget';

const SUPPORTED_MIME_TYPES = ['Files', FILES_MIME_TYPE, SOURCES_MIME_TYPE, TFI_MIME_TYPE];

const SEQUENCE_EXTENSIONS = [
  '.ab1',
  '.dna',
  '.fasta',
  '.gb',
  '.gbk',
  '.gcc',
  '.gck',
  '.gcs',
  '.genbank',
  '.geneious',
  '.phd.1',
  '.sbd',
  '.seq',
  '.str',
  '.xdna',
  '.zip',
];

export function getFolderDropError(
  folder: FolderConstants.NumberIDFolder | FolderConstants.StringIDFolder
): string | null {
  if (folder) {
    // @ts-expect-error FIXME - `isArchived` does not work with NumberIDFolder since folder.id
    // is `number` not `string`
    if (isArchived(folder)) {
      return 'Files cannot be moved into an archived folder.';
      // @ts-expect-error FIXME - folder.permissions could be undefined
    } else if (!folder.permissions.writable) {
      return 'Files cannot be moved into a read-only folder.';
    }
  }
  return null;
}

/* @package */
export interface FolderDropTargetProps {
  className?: string;
  component?: DropTargetClass['props']['component'];
  shouldCaptureDrop: boolean;
  validateDrop?: (...args: Array<any>) => any;
  folder?: {
    id: string;
    name: string;
    url: string;
    type: any; // TODO: PropTypes.oneOf([ FolderConstants.Type.ALL, FolderConstants.Type.INVENTORY, FolderConstants.Type.NOTEBOOK, ])
    parent?: any;
    source?: {
      name: string;
      sourceType: any; // TODO: PropTypes.oneOf([PROJECT_TYPE, REGISTRY_TYPE])
      url: string;
    };
  } | null;
  section?: any; // TODO: PropTypes.oneOf([INVENTORY_SECTION, NOTEBOOK_SECTION, ALL_SECTION])
}

class FolderDropTarget extends React.Component<FolderDropTargetProps> {
  _isNotebookSection = (): boolean =>
    this.props.folder!.type === FolderConstants.Type.NOTEBOOK ||
    (this.props.folder!.type === FolderConstants.Type.ALL && this.props.section === NOTEBOOK_SECTION);

  _isNotebookItem = (item: any): boolean => {
    const type = APIUtil.apiIdToType(item.id);
    return (
      Array.from(NOTEBOOK_ITEMS).includes(type) ||
      (type === ModelTypeConstants.FOLDER && item.type === FolderConstants.Type.NOTEBOOK)
    );
  };

  validateDrop = (e: any): string | undefined => {
    if (
      (this.props.folder != null ? this.props.folder.source : undefined) != null &&
      this.props.folder!.source!.sourceType === REGISTRY_TYPE
    ) {
      return `To add an entity to a registry, first import the entity into a project then register it via the \
expanded projects view.`;
    }
    return typeof this.props.validateDrop === 'function' ? this.props.validateDrop(e) : undefined;
  };

  handleSystemFileDrop = (e: any): void => {
    // Save reference to files, since e.dataTransfer gets destroyed by the time async callbacks run.
    // Also, convert it to an Array (some browsers use a FileList).
    const files: Array<File> = Array.from(e.dataTransfer.files);
    const mayContainSequences = SEQUENCE_EXTENSIONS.some((ext) =>
      files.some((file) => file.name.endsWith(ext))
    );

    // Prevent user from uploading data files or from uploading sequences to notebook folder
    if (!mayContainSequences) {
      notifications.warn('Data files (e.g. images) should be uploaded directly into notebook entries.');
      return;
    }

    // Promise resolves if sequence import should be used and rejects otherwise.
    const IMPORT_SEQUENCES = 'import-sequences';
    const IMPORT_CANCEL = 'import-cancel';
    const openImportPromise = mayContainSequences
      ? modals.multiOption(
          'Import as Sequence?',
          `It looks like one or more files contain sequence data\u2014would you like to \
import them as Benchling sequences? To import as data files, please upload them \
directly into notebook entries.`,
          [
            {
              text: 'Yes, import as sequences',
              style: 'success',
              pullLeft: true,
              value: IMPORT_SEQUENCES,
            },
            {
              text: 'Cancel',
              value: IMPORT_CANCEL,
            },
          ]
        )
      : undefined;
    openImportPromise!.done((value: any) => {
      if (value === IMPORT_SEQUENCES) {
        legacyRunModal(ImportSequenceModalClass, {
          initialFiles: files,
          openImportResults: false,
          targetFolderId: this.props.folder!.id,
        });
      }
    });
  };

  afterConfirmation = (file: FolderItem): void => {
    FileBrowserActions.moveItemsWithDataMods(
      [file.id],
      this.props.folder!.id,
      {
        parentFolderIds: [file.parentFolderId],
        hasRegisteredItems: file.source?.sourceType === REGISTRY_TYPE,
      },
      () => file.isShortcut
    );
  };

  confirmMove = (type: any, name: any, url: any): JQueryPromise<boolean> => {
    assert(type !== PROJECT_TYPE, 'Unexpectedly attempting to move a project');
    const typeName = typeToName(type);
    return modals.confirm(
      `Move ${capwords(typeName)}`,
      <div>
        {/* TODO(T1749): Show warning about permissions changing if source will ever be changing. */}
        <p>
          {'Are you sure you want to move '}
          {this.renderELNLink(url, name)}
          {' into '}
          {this.renderELNLink(this.props.folder!.url, this.props.folder!.name)}?
        </p>
        <p className="faded">
          <strong>Note: </strong>
          <span>{`The ${typeName} will inherit the permissions of ${this.props.folder!.name}.`}</span>
        </p>
      </div>
    );
  };

  handleDrop = (e: any): void => {
    if (e.dataTransfer.files.length) {
      this.handleSystemFileDrop(e);
      return;
    }

    const bd = BenchlingData(e);

    // If a TFI file is being dragged, import it to this folder
    const tfiObject = bd.getData<typeof TFI_MIME_TYPE>(TFI_MIME_TYPE);
    if (tfiObject) {
      notifications.warn('Drag this file directly into an entry or note to store it in Benchling.');
      return;
    }

    const sources = bd.getData<typeof SOURCES_MIME_TYPE>(SOURCES_MIME_TYPE);
    if (sources != null) {
      notifications.warn('Moving projects is not currently permitted.');
      return;
    }

    const files = bd.getData<typeof FILES_MIME_TYPE>(FILES_MIME_TYPE);
    if (files == null) {
      // data validation may have failed in BenchlingData
      notifications.warn(DropTargetClass.dropErrorMessage('folder'));
      return;
    }
    if (files.length > 1) {
      // TODO(eln): Support multiple files when dragging multiple files is supported.
      notifications.warn('Moving multiple files is not currently permitted.');
      return;
    }
    if (files.length === 0) {
      return;
    }
    const [file] = Array.from(files);

    // TODO(T2224): add mimetype to distinguish these cases before file is dropped
    const type = APIUtil.apiIdToType(file.id);
    // If file already lives in folder, no-op.
    // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
    if (file.parentFolderId === this.props.folder.id) {
      return;
    }

    // Disallow dropping a file into itself or its parent.
    // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
    if ([file.id, file.parentFolderId].includes(this.props.folder.id)) {
      return;
    }

    // Prevent modal from popping up when moving within the same project BNCH-35558
    // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
    if (file?.source?.rootFolder?.id === this.props.folder?.source?.rootFolder?.id) {
      this.afterConfirmation(file as FolderItem);
      return;
    }

    // Confirm/notify move.
    this.confirmMove(type, file.name, file.url).done(() => {
      this.afterConfirmation(file as FolderItem);
    });
  };

  renderELNLink = (url: any, name: any): JSX.Element => (
    <a
      href={url}
      onClick={function (e: any): void {
        benchlingUtil.navigate(e);
      }}
    >
      {name}
    </a>
  );

  override render(): JSX.Element {
    return (
      <DropTargetClass
        // eslint-disable-next-line no-restricted-syntax
        {..._.extend({}, _.omit(this.props, 'folder', 'section'), {
          shouldCaptureDrop: this.props.shouldCaptureDrop,
          mimeTypes: SUPPORTED_MIME_TYPES,
          validateDrop: this.validateDrop,
          dropEffect: 'move',
          targetDesc: 'folder',
          onDrop: this.handleDrop,
        })}
      >
        {this.props.children}
      </DropTargetClass>
    );
  }
}

export default FolderDropTarget;

interface FolderItem {
  id: string;
  parentFolderId: string;
  source?: {
    name: string;
    sourceType: any;
    url: string;
  };
  isShortcut: boolean;
  name: string;
  url: string;
}
